"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiMessages = exports.skuCardMessages = exports.uploadModalMessages = exports.skuSearchMessages = exports.skuBinMessages = void 0;

var _reactIntl = require("react-intl");

var skuBinMessages = (0, _reactIntl.defineMessages)({
  emptyBinPlaceholder: {
    id: 'skuSelector.emptyBinPlaceholder',
    description: 'Placeholder for empty search bin in the sku selector.',
    defaultMessage: 'Search for products by their name or SKU and add them here.'
  },
  noFilterResult: {
    id: 'skuSelector.skuBinNoFilterResult',
    description: 'Message for an empty filter search in the sku selector sku bin.',
    defaultMessage: "No results found for '{filter}'."
  },
  csvDownloadLink: {
    id: 'skuSelector.csvDownloadLink',
    description: 'Text for the csv download link in the sku bin.',
    defaultMessage: '{number} Total Skus (Click here to download CSV)'
  },
  filterLabel: {
    id: 'skuSelector.searchFilterLabel',
    description: 'Label for the sku bin search filter bar.',
    defaultMessage: 'Filter by keyword...'
  },
  removeSkuButtonText: {
    id: 'skuSelector.removeSkuButtonText',
    description: 'Text for the bulk remove sku button.',
    defaultMessage: 'Remove SKUs'
  },
  filterTitle: {
    id: 'skuSelector.filterOptionsTitle',
    description: 'Title for the sku bin search filter option list.',
    defaultMessage: 'Filter Options'
  },
  skuFilter: {
    id: 'skuSelector.skuFilterLabel',
    description: 'Label for the sku filter checkbox in the sku bin search filter option list.',
    defaultMessage: 'Sku'
  },
  descriptionFilter: {
    id: 'skuSelector.descriptionFilterLabel',
    description: 'Label for the description filter checkbox in the sku bin search filter option list.',
    defaultMessage: 'Description'
  },
  nameFilter: {
    id: 'skuSelector.nameFilterLabel',
    description: 'Label for the name filter checkbox in the sku bin search filter option list.',
    defaultMessage: 'Name'
  },
  csvName: {
    id: 'skuSelector.csvDownloadName',
    description: 'Filename for the csv sku download file.',
    defaultMessage: 'all_skus.csv'
  }
});
exports.skuBinMessages = skuBinMessages;
var skuSearchMessages = (0, _reactIntl.defineMessages)({
  defaultErrorMessage: {
    id: 'skuSelector.skuSearchDefaultErrorMessage',
    description: 'Default error message in the sku search component.',
    defaultMessage: 'Something went wrong'
  },
  detailedErrorMessage: {
    id: 'skuSelector.skuSearchDetailedErrorMessage',
    description: 'Detailed error message in the sku search component.',
    defaultMessage: '{error}. Please try again.'
  },
  notFoundErrorMessage: {
    id: 'skuSelector.skuSearchNotFoundErrorMessage',
    description: 'No products found error message in the sku search component.',
    defaultMessage: "No products found for '{query}'"
  },
  previousButtonText: {
    id: 'skuSelector.skuSearchPrevButtonText',
    description: 'Text for the previous button in the sku search component.',
    defaultMessage: 'Previous'
  },
  nextButtonText: {
    id: 'skuSelector.skuSearchNextButtonText',
    description: 'Text for the next button in the sku search component.',
    defaultMessage: 'Next'
  },
  addPrompt: {
    id: 'skuSelector.skuSearchAddSkuPrompt',
    description: 'Prompt for adding multiple skus in the sku search component.',
    defaultMessage: 'Want to add multiple skus at once?'
  },
  addButtonText: {
    id: 'skuSelector.skuSearchAddSkuButtonText',
    description: 'Text on the button for adding multiple skus in the sku search component.',
    defaultMessage: 'Add SKUs'
  },
  searchBarLabel: {
    id: 'skuSelector.skuSearchBarLabel',
    description: 'Label for the search bar in the sku search component.',
    defaultMessage: 'Type in a product name or SKU'
  },
  searchBarHelpText: {
    id: 'skuSelector.skuSearchBarHelpText',
    description: 'Help text for the search bar in the sku search component.',
    defaultMessage: 'Start typing above to search for products'
  },
  currentlyViewingText: {
    id: 'skuSelector.currentlyViewingText',
    description: 'Currently viewing text in the sku search component.',
    defaultMessage: 'Currently viewing '
  },
  skuCountText: {
    id: 'skuSelector.skuCountText',
    description: 'Sku count text in the sku search component.',
    defaultMessage: 'out of {totalCount} skus'
  }
});
exports.skuSearchMessages = skuSearchMessages;
var uploadModalMessages = (0, _reactIntl.defineMessages)({
  addSkuError: {
    id: 'skuSelector.uploadModalAddError',
    description: 'Error message for adding skus in the sku upload modal.',
    defaultMessage: 'The above SKUs could not be added because they do not exist on the platform.  They may contain typos, such as non-alphanumeric characters or improper capitalization. Please review them and try again.'
  },
  removeSkuError: {
    id: 'skuSelector.uploadModalRemoveError',
    description: 'Error message for removing skus in the sku upload modal.',
    defaultMessage: 'The above SKUs could not be removed as they are marked as unremoveable.'
  },
  helpText: {
    id: 'skuSelector.uploadModalHelpText',
    description: 'Help text for the sku upload modal.',
    defaultMessage: 'Enter a list of SKUs separated by spaces. Processing thousands of SKUs at once may take some time. If you experience significant delays, try making several smaller uploads.'
  },
  addTitle: {
    id: 'skuSelector.uploadModalAddTitle',
    description: 'Title for the add sku upload modal.',
    defaultMessage: 'Add SKUs'
  },
  removeTitle: {
    id: 'skuSelector.uploadModalRemoveTitle',
    description: 'Title for the remove sku upload modal.',
    defaultMessage: 'Remove SKUs'
  },
  addButtonText: {
    id: 'skuSelector.uploadModalAddButtonText',
    description: 'Text for the add button in the sku upload modal.',
    defaultMessage: 'Add ({totalCount})'
  },
  removeButtonText: {
    id: 'skuSelector.uploadModalRemoveButtonText',
    description: 'Text for the remove button in the sku upload modal.',
    defaultMessage: 'Remove ({totalCount})'
  },
  closeButtonText: {
    id: 'skuSelector.uploadModalCloseButtonText',
    description: 'Text for the close button in the sku upload modal.',
    defaultMessage: 'Close'
  },
  skuLabel: {
    id: 'skuSelector.uploadModalSkuLabel',
    description: 'Label for the sku entry field in the sku upload modal.',
    defaultMessage: 'SKUs'
  }
});
exports.uploadModalMessages = uploadModalMessages;
var skuCardMessages = (0, _reactIntl.defineMessages)({
  disabledTooltip: {
    id: 'skuSelector.skuCardDisabledTooltip',
    description: 'Tooltip for disabled sku cards.',
    defaultMessage: 'The selector is currently disabled. This product cannot be added or removed from your list.'
  }
});
exports.skuCardMessages = skuCardMessages;
var apiMessages = (0, _reactIntl.defineMessages)({
  discoverabilityServiceComment: {
    id: 'skuSelector.discoverabilityServiceComment',
    description: 'Service comment for discoverability service api calls.',
    defaultMessage: 'validating skus'
  },
  errorTemplate: {
    id: 'skuSelector.apiErrorTemplate',
    description: 'Error template for sku selector api calls.',
    defaultMessage: 'Error while {serviceComment}. (Response Code: {status})'
  },
  sceneServiceComment: {
    id: 'skuSelector.apiSceneServiceComment',
    description: 'Service comment for scene service api calls.',
    defaultMessage: 'getting scene uri'
  },
  skuServiceComment: {
    id: 'skuSelector.apiSkuServiceComment',
    description: 'Service comment for sku service api calls.',
    defaultMessage: 'searching for skus'
  }
});
exports.apiMessages = apiMessages;